import '../styles/ContactPage.css';
import ContactForm from './ContactForm';
import { User, Phone } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="about-content-wrapper">
      <div className="contact-hero">
        <div className="contact-title">
          <h1>Contact Us</h1>
        </div>
      
      
      <div className="contact-content">
        <div className="contact-info">
          <div className="location-section">
            <div className="divider"></div>
          </div>

          {/* Contact Persons Section */}
          <div className="contact-persons">
            <h3 className="contact-persons-title">For Bookings and Enquiries</h3>
            <p className="whatsapp-info">Contact us on WhatsApp</p>
            
            {/* Contact Person 1 - Sushil Adap */}
            <div className="contact-person-card">
              <div className="contact-person-header">
                <User size={24} className="contact-person-icon" />
                <div>
                  <h4 className="contact-person-name">Sushil Adap</h4>
                </div>
              </div>
              <div className="contact-person-details">
                <div className="contact-detail">
                  <Phone size={18} className="contact-icon" />
                  <span className="contact-number">+91 98672 92012</span>
                </div>
              </div>
            </div>

            {/* Contact Person 2 - Aliakbar TP */}
            <div className="contact-person-card">
              <div className="contact-person-header">
                <User size={24} className="contact-person-icon" />
                <div>
                  <h4 className="contact-person-name">Aliakbar TP</h4>
                </div>
              </div>
              <div className="contact-person-details">
                <div className="contact-detail">
                  <Phone size={18} className="contact-icon" />
                  <span className="contact-number">+91 80781 70057</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="contact-form-container">
          <ContactForm />
        </div>
      </div>
      </div>
    </div>
    </div>
  );
};

export default ContactPage;